import Set from "core-js/es6/set";

import _ from "lodash";

import ko from "rgs-knockout";

import { JSable } from "jsable";

import {
	MyRgsUserPerson,
	MyRgsUserJuridicalPerson,
} from "myrgs-user-person-model";

export class MyRgsProfile extends JSable {
	constructor(options) {
		super();

		this.IsAuthenticated = ko.observable().extend({ toFromJS: true });

		this.IsTemporaryPassword = ko.observable().extend({ toFromJS: true });

		this.IsKeyClient = ko.observable().extend({ toFromJS: true });

		this.IsEnabledBsoDelivery = ko.observable().extend({ toFromJS: true });

		this.IsPersonalDataProcessingAccepted = ko
			.observable()
			.extend({ toFromJS: true });

		this.IsProcessedForSubscribe = ko
			.observable()
			.extend({ toFromJS: true });

		this.UserProfileID = ko.observable().extend({ toFromJS: true });

		this.Email = ko.observable().extend({ toFromJS: true });

		this.Login = this.Email;

		this.Roles = ko.observable().extend({ toFromJS: true });

		this.PersonType = ko.observable().extend({ toFromJS: true });

		this.PhysicalPerson = this._newMyRgsUserPerson(options);
		this.JuridicalPerson = this._newMyRgsUserJuridicalPerson(options);

		this.ApplicationSignatureStatus = ko
			.observable()
			.extend({ toFromJS: true });

		this.BranchCode = ko.observable().extend({ toFromJS: true });

		this.PrivateNumberEmployee = ko.observable().extend({ toFromJS: true });

		this.EkisBaseId = ko.observable().extend({ toFromJS: true });

		this.CurrentCompanyClientId = ko
			.observable()
			.extend({ toFromJS: true });
	}

	hasRole(role) {
		return _.includes(this.Roles(), role);
	}

	hasAnyRole(...roles) {
		return !_.isEmpty(_.intersection(this.Roles(), roles));
	}

	hasEveryRole(...roles) {
		return _.isEqual(
			new Set(_.intersection(this.Roles(), roles)),
			new Set(roles)
		);
	}

	_newMyRgsUserPerson() {
		return new MyRgsUserPerson(...arguments);
	}

	_newMyRgsUserJuridicalPerson() {
		return new MyRgsUserJuridicalPerson(...arguments);
	}

	getEmail () {
		return this.Email();
	}
}
